import { defineMessages } from "react-intl";

export const messages: { [key: string]: { id: string; defaultMessage: string } } = defineMessages({
  applyTo: {
    id: "ari.management.applyTo.applyTo",
    defaultMessage: "Apply to",
  },
  inventoryLines: {
    id: "ari.management.applyTo.inventoryLines",
    defaultMessage: "Inventory lines",
  },
  extras: {
    id: "ari.management.applyTo.extras",
    defaultMessage: "Extras",
  },
  promos: {
    id: "ari.management.applyTo.promos",
    defaultMessage: "Promos",
  },
  complements: {
    id: "ari.management.applyTo.supplements",
    defaultMessage: "Supplements",
  },
  bundles: {
    id: "ari.management.applyTo.bundles",
    defaultMessage: "Packages",
  },
  allAccommodations: {
    id: "ari.management.applyTo.allAccommodations",
    defaultMessage: "Accommodations",
  },
  allRates: {
    id: "ari.management.applyTo.allRates",
    defaultMessage: "Rates",
  },
  allMealplans: {
    id: "ari.management.applyTo.allMealplans",
    defaultMessage: "Mealplans",
  },
  allOccupancies: {
    id: "ari.management.applyTo.allOccupancies",
    defaultMessage: "Occupancy",
  },
  selectAll: {
    id: "ari.management.applyTo.selectAll",
    defaultMessage: "Select all",
  },
  unselectAll: {
    id: "ari.management.applyTo.unselectAll",
    defaultMessage: "Unselect all",
  },
  filterComplementsPlaceholder: {
    id: "ari.management.applyTo.filterComplementsPlaceholder",
    defaultMessage: "Filter complements...",
  },
});
